import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { AuthService } from '../../../@core/auth/auth.service';
import { environment } from '../../../../environments/environment';
import { StorageTypeDTO } from '../../modules/pick-plan/models/storage-types-dto';
import { Observable } from 'rxjs';




@Injectable({
  providedIn: 'root'
})
export class StorageService {
  protected basePath = '/';

  constructor(
    protected httpClient: HttpClient,
    private authService: AuthService,
  ) {
    this.basePath = environment.PLATFORM_API_URL;
  }

  public getStorageTypes(includeInactive: boolean = false): Observable<StorageTypeDTO[]> {


    let queryParameters = new HttpParams();

    if (includeInactive !== undefined && includeInactive !== null) {
      queryParameters = queryParameters.set('includeInactive', String(includeInactive));
    }

    return this.httpClient.get<StorageTypeDTO[]>(`${this.basePath}/api/storagetypes`);
  }

  public getStorageType(storageTypeId: number): Observable<StorageTypeDTO> {
    return this.httpClient.get<StorageTypeDTO>(`${this.basePath}/api/storagetypes/${storageTypeId}`);
  }

  public postStorageTypeDTO(storageTypeDTO: StorageTypeDTO): Observable<StorageTypeDTO> {
    return this.httpClient.post<StorageTypeDTO>(`${this.basePath}/api/storagetypes`, storageTypeDTO);
  }

  public putStorageTypeDTO(storageTypeDTO: StorageTypeDTO): Observable<StorageTypeDTO> {
    return this.httpClient.put<StorageTypeDTO>(`${this.basePath}/api/storagetypes/${storageTypeDTO.id}`, storageTypeDTO);
  }

  public deleteStorageTypeDTO(id: number): Observable<any> {
    return this.httpClient.delete(`${this.basePath}/api/storagetypes/${id}`);
  }

}
